import { useI18n } from "./integrations/formatjs/I18nContext";
const useI18nNumber = ({ domain, value, style, currency, unit, unitDisplay, }) => {
    const intl = useI18n({ domain });
    const formatted = intl.formatNumber(value, {
        style,
        currency,
        unit,
        unitDisplay,
    });
    if (currency === "CHF" && value < 0) {
        const match = formatted.match(/^CHF-(.*)$/);
        if (match) {
            return `-CHF ${match[1]}`;
        }
    }
    return formatted;
};
export { useI18nNumber };
